import React, { CSSProperties, ReactNode } from "react";
import { Footer } from "./footer";

export interface TemplateViewProps {
  children: React.ReactNode;
  header?: ReactNode;
}

const styles: { [key: string]: CSSProperties } = {
  wrapper: {
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    alignSelf: "center",
    height: "100%",
    width: "100%",
    padding: "0 10px",
  },
};

export const TemplateView = ({ header, children }: TemplateViewProps) => {
  return (
    <>
      <div className="h-100 d-flex flex-column">
        {header && header}
        <div style={styles.wrapper}>{children}</div>
        <Footer />
      </div>
    </>
  );
};
